module.exports = __webpack_public_path__ + "assets/img/page4-nav-item-9-3ad9aeaa.png";